export interface LeadAttributeConfig {
  property_name: string;
  property: string;
  type: 'text' | 'number' | 'dropdown';
  prefix?: string;
  options?: Record<string, number>;
}

export const DefaultLeadAttributes = {
  approved_loan_amount: null,
  lead_status: null,
  seeking_partnership: null,
  status_notes: '',
  veteran_status: null,
  viability_rating: null,
};

export const LEAD_ATTRIBUTE_CONFIG: LeadAttributeConfig[] = [
  {
    property_name: 'Lead Status',
    property: 'lead_status',
    type: 'dropdown',
    options: {
      'Select Lead Status': 0,
      'Under review': 1,
      'Further information required': 2,
      'Prospective client': 3,
      'On hold': 4,
      Declined: 5,
      'Not currently pursuing': 6,
      'Active client': 7,
      'Request lead contact': 8,
      'Active Funded': 9,
      'Active Funded Grant': 10,
      'Active Technical Assistance': 11,
    },
  },
  {
    property_name: 'Status Notes',
    property: 'status_notes',
    type: 'text',
  },
  {
    property_name: 'Viability Rating',
    property: 'viability_rating',
    type: 'dropdown',
    options: {
      'Select Viability Rating': 0,
      'Low viability': 1,
      'Below average viability': 2,
      'Average viability': 3,
      'Above average viability': 4,
      'High viability': 5,
    },
  },
  {
    property_name: 'Seeking Partnership',
    property: 'seeking_partnership',
    type: 'dropdown',
    options: {
      'Select Seeking Partnership': 0,
      'Seeking funding partner': 1,
      'Seeking technical assistance': 2,
      Unknown: 3,
    },
  },
  {
    property_name: 'Military Service',
    property: 'veteran_status',
    type: 'dropdown',
    options: {
      'Select Military Service': 0,
      Yes: 1,
      No: 2,
      'N/A': 3,
    },
  },
  {
    property_name: 'Approved Loan Amount',
    property: 'approved_loan_amount',
    type: 'number',
    prefix: '$',
  },
];
